import React, { act, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { fetchAppointments, deleteAppointment } from './appointmentSlice';
import { Appointment } from './types';
import { AppDispatch, RootState } from '@app/store';
import { ModeEdit, Note, Schedule, ScheduleRounded } from '@mui/icons-material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { Card, CardContent } from '@/components/ui/card';
import { Calendar, Edit, InfoIcon, Search, Trash2Icon } from 'lucide-react';
import { CircularProgress, IconButton } from '@mui/material';
import { fetchProducts } from '../Element/productSlice';
import AppointmentSchedule from './AppointmentScheduleModal';

import { fetchClients } from '../Client';
import { fetchUsers } from '../user';
import { fetchRoles } from '../role';
import { fetchAffiliates } from '../affiliate';
const AppointmentList: React.FC = (props:any) => {
  const dispatch = useDispatch<AppDispatch>();
  const appointments = useSelector((state: RootState) => state.appointment.items);
  const loading = useSelector((state: RootState) => state.appointment.loading);

    const { items: affiliates, loading: affiliatesLoading } = useSelector(
      (state: RootState) => state.affiliate
    );

  const { items:clients } = useSelector((state: RootState) => {
      console.log('🔍 Selector executando, loading:', state.client.loading);
      return state.client;
    });

     const { items:users } = useSelector((state: RootState) => {
      console.log('🔍 Selector executando, loading:', state.user.loading);
      return state.user;
    });

     const { items:roles } = useSelector((state: RootState) => {
      console.log('🔍 Selector executando, loading:', state.role.loading);
      return state.role;
    });

  const [search, setSearch] = useState('');
  const [loading_all,setLoadingAll] = useState(true);

  const [product,setProduct] = useState('');
  const [phase,setPhase] = useState('');
  const [open,setOpen] = useState(false);

  const [activity,setActivity] = useState('');


  const navigate = useNavigate();

  useEffect(() => {
   fetchApp();
  }, [dispatch]);

    useEffect(() => {
      if(props.setTotalAppointments){
        props.setTotalAppointments(appointments?.length)

      }
  }, [appointments]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
      const { name, value } = e.target;
      if(name=='product'){
        setProduct(value);
        setPhase('')
        setActivity('');

      }
      else if(name=='phase'){
        setPhase(value);
        setActivity('');
      } 
      else if(name=='activity'){
        setActivity(value);
      } 
    };

  const fetchApp = async()=>{
    setLoadingAll(true)
    await dispatch(fetchAppointments({} as Record<string, string>));
            await dispatch(fetchProducts());
                  await dispatch(fetchClients({}));
                  await dispatch(fetchUsers({}));
                  await dispatch(fetchRoles({}));
                          await dispatch(fetchAffiliates({}));
                  


            
    
    setLoadingAll(false)
  }

  

      const { products, loading:loading_products, error } = useSelector((state: RootState) => state.product);
  

  const handleDelete = async (id: string) => {
    if (window.confirm('Tem certeza que deseja excluir esta configuração de agendamento?')) {
      await dispatch(deleteAppointment(id));
      dispatch(fetchAppointments({} as Record<string, string>));

    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const filteredAppointments = appointments?.filter((appointment: Appointment) => {
    return appointment.name?.toLowerCase().includes(search?.toLowerCase()) ||
      (appointment.description && appointment.description?.toLowerCase().includes(search?.toLowerCase()));
  }).filter((item:any)=>{
    if(product==''){
      return true;
    }
    else{
      if(item.product==product){
        if(phase==''){
          return true;
        }else{
          if(item.phase==phase){
            if(activity==''){
              return true;
            }
            else{
              if(activity==item.activity){
                return true
              }
              return false
            }
          }
          return false;
        }
      }
      else{
        return false;
      }
    }
  }) || [];

  const formatWeekDays = (weekDayAvailability: Appointment['weekDayAvailability']) => {
    if (!weekDayAvailability) return 'N/A';

    const days = [];
    if (weekDayAvailability.monday) days.push('Seg');
    if (weekDayAvailability.tuesday) days.push('Ter');
    if (weekDayAvailability.wednesday) days.push('Qua');
    if (weekDayAvailability.thursday) days.push('Qui');
    if (weekDayAvailability.friday) days.push('Sex');
    if (weekDayAvailability.saturday) days.push('Sáb');
    if (weekDayAvailability.sunday) days.push('Dom');

    return days.join(', ');
  };

  const formatTimeBlocks = (timeBlocks: Appointment['timeBlocks']) => {
    if (!timeBlocks || timeBlocks.length === 0) return 'N/A';

    return timeBlocks.map(block => `${block.startTime} - ${block.endTime}`).join(', ');
  };

  if (loading || loading_all) {
  return <div style={{display:'flex',height:'100vh',justifyContent:'center',alignItems:'center'}}>            <CircularProgress />
  </div>;
  }

  return (
    <div className={"flex flex-col flex-1 shrink  self-stretch  basis-0 min-w-60 max-md:px-5 bg-background-dark "+(props.hide_header!=true?'px-6 py-7':'')}>

      {props?.hide_header!=true && <div className=" justify-between items-center mb-6">

        <h1 className="text-2xl font-bold">Agendas ({appointments.length})</h1>
        {/* {subtitle && <p style={{color:'grey'}} className="mt-1">{subtitle}</p>} */}
      </div>}
      <div className="mb-4 flex w-full" style={{ position: 'relative',flexWrap:'wrap',justifyContent:'space-between' }}>
        <div style={{width:'100%'}}>
          <label className="text-sm font-semibold text-gray-700">
                Produtos ({products.length})
              </label>
              <select
                name="product"
                value={product}
                onChange={handleChange}
                required
                style={{ fontSize: '0.875rem', padding: 5,borderRadius:20 }}
                className={`h-12 mt-1 w-full border rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 `}
              >
                <option value={''}>
                  Selecione um produto
                </option>
                {products?.map((product: any) => (
                  <option key={product._id} value={product._id}>
                    {product.name}
                  </option>
                ))}
              </select>
        </div>

        <div style={{width:'48%'}} className='mt-1'>
          <label className="text-sm font-semibold text-gray-700">
                Fases {product!='' && ('('+products?.filter((item)=>item._id==product)[0].phases.length+')')}
              </label>
              <select
                name="phase"
                value={phase}
                onChange={handleChange}
                required
                style={{ fontSize: '0.875rem', padding: 5,borderRadius:20 }}
                className={`h-12 mt-1 w-full border rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 `}
              >
                <option value={''}>
                  Selecione uma fase
                </option>
                {product!='' && products?.filter((item)=>item._id==product)[0].phases.map((product: any) => (
                  <option key={product._id} value={product._id}>
                    {product.name}
                  </option>
                ))}
              </select>
        </div>

        <div style={{width:'48%'}} className='mt-1'>
          <label className="text-sm font-semibold text-gray-700">
                Atividades {product!='' && phase!='' && ('('+ products?.filter((item)=>item._id==product)[0].phases.filter((item)=>item._id==phase)[0].activities.length+')')}
              </label>
              <select
                name="activity"
                value={activity}
                onChange={handleChange}
                required
                style={{ fontSize: '0.875rem', padding: 5,borderRadius:20 }}
                className={`h-12 mt-1 w-full border rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 `}
              >
                <option value={''}>
                  Selecione uma atividade
                </option>
                {product!='' && phase!='' && products?.filter((item)=>item._id==product)[0].phases.filter((item)=>item._id==phase)[0].activities.map((product: any) => (
                  <option key={product._id} value={product._id}>
                    {product.name}
                  </option>
                ))}
              </select>
        </div>

      </div>

      <div className="mb-4 flex w-full" style={{ position: 'relative' }}>
        <input
          type="text"
          value={search}
          onChange={handleSearchChange}
          placeholder="Pesquisar"
          className="p-2 border rounded"
          style={{ width: '-webkit-fill-available', marginRight: 20, borderRadius: 20, paddingLeft: 40 }}
        />
        <Search style={{ position: 'absolute', top: '20%', left: 10, color: 'grey' }} />
        <Link to={`/appointments/new`} style={{ width: 160, borderRadius: 20 }} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
          <p style={{ whiteSpace: 'nowrap' }}>{'Adicionar'} <AddIcon /></p>
        </Link>
        <button onClick={(e)=>{
          setOpen(true);
        }} style={{ borderRadius: 20 }} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 ml-1">
          <p style={{ whiteSpace: 'nowrap' }}>{'Agendar'} <ScheduleRounded /></p>
        </button>
      </div>
      

      <AppointmentSchedule onData={async()=>{
                  await dispatch(fetchClients({}));

      }} appointments={appointments} affiliates={affiliates} roles={roles} users={users} products={products} clients={clients} open={open} onClose={() => setOpen(false)} />
      <Card style={{maxHeight:window.innerHeight-350, overflow: 'scroll'}} className="custom-scrollbar w-full border border-[#D8E0F0] rounded-[14px] bg-[#FCFCFC] hover:border-[#c8d0e0] transition-colors">
        <CardContent className="p-[20px] ">





          <div className="overflow-x-auto">
            <table className="min-w-full ">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredAppointments.length > 0 ? (
                  filteredAppointments.map((appointment: Appointment, id) => (
                    <>
                    <tr>
                      <td style={{ width: 70, margin: 0, padding: 0 }}>
                        <div style={{ padding: 10, height: 75, border: '1px solid lightgrey', borderRadius: 10, borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: 0, borderLeft: '1px solid lightgrey' , borderTopLeftRadius: 10 , borderBottomLeftRadius: 10  }}>
                          <div style={{ border: '1px solid lightgrey', borderRadius: 10, minWidth: 51, minHeight: 51, width: 51, height: 51, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {/* {<Calendar color='rgb(37 99 235 / var(--tw-bg-opacity, 1))' />} */}
                            {/* <img /> */}
                        {<img style={{    minWidth:45,minHeight:45, width: 45, height: 45, objectFit: 'cover', borderRadius: 10 }} src={(appointment.image ? appointment.image : '/icon_agenda.png')} />}

                          </div>
                        </div>
                      </td>
                      <td style={{ minWidth: 200, margin: 0, padding: 0 }}>
                        <div style={{ padding: 10, height: 75, border: '1px solid lightgrey', borderRadius: 10, borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: 0, borderLeft: 0, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>

                          <div>
                            <p style={{
                              color: 'grey', fontSize: 14,
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              width: 100,
                              display: 'block',
                              overflow: 'hidden'

                            }}>Agenda</p>
                            <p style={{
                              color: 'black', textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              // width: 200,
                              display: 'block',
                              overflow: 'hidden'

                            }}><b style={{ fontWeight: 'normal' }}>{appointment.name}</b></p>
                          </div>
                        </div>

                      </td>

                      <td style={{ minWidth: 200, margin: 0, padding: 0 }}>
                        <div style={{ padding: 10, height: 75, border: '1px solid lightgrey', borderRadius: 10, borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: 0, borderLeft: 0, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>

                          <div>
                            <p style={{
                              color: 'grey', fontSize: 14,
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              width: 100,
                              display: 'block',
                              overflow: 'hidden'

                            }}>Produto</p>
                            <p style={{
                              color: 'black', textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              // width: 200,
                              display: 'block',
                              overflow: 'hidden'

                            }}><b style={{ fontWeight: 'normal' }}>{appointment.product?(products.filter((item)=>item._id==appointment.product)[0]?.name) :''}</b></p>
                          </div>
                        </div>

                      </td>

                      <td style={{ margin: 0, padding: 0 }}>
                        <div className="flex items-center" style={{ justifyContent:'flex-end', height: 75, padding: 10, border: '1px solid lightgrey', borderRadius: 10, borderLeft: 0, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
<div
                            style={{ marginRight: 5, display:'flex',justifyContent:'center',alignItems:'center', background: '#f2f2f2', borderRadius: 10, width: 35, height: 35,color:'grey' }}
                          
                          >

                          {<IconButton
                            style={{  borderRadius: 10, width: 35, height: 35,color:'grey' }}
                            onClick={() => navigate(`/appointments/edit/${appointment._id}`)}
                          >
                            <Edit />
                          </IconButton>}
                          </div>

                          {/* <div
                            style={{ marginRight: 5, display:'flex',justifyContent:'center',alignItems:'center', background: '#f2f2f2', borderRadius: 10, width: 35, height: 35,color:'grey' }}
                          >
 {<IconButton
                            style={{  borderRadius: 10, width: 28, height: 28,color:'grey' }}

                            size='small'
                            onClick={() => navigate(`/appointments/edit/${appointment._id}`)}
                          >
                            <InfoIcon />
                          </IconButton>}
                          </div> */}
                         <div
                            style={{ marginRight: 5, display:'flex',justifyContent:'center',alignItems:'center', background: '#f2f2f2', borderRadius: 10, width: 35, height: 35,color:'grey' }}
                          
                          >

                          {(
                            <IconButton
                            style={{  borderRadius: 10, width: 35, height: 35,color:'grey' }}

                              onClick={() => handleDelete(appointment._id as string)}
                            >
                              <Trash2Icon />
                            </IconButton>
                          )}
                          </div>

                         
                        </div>
                      </td>
                    </tr>
                  <tr style={{height:10}}></tr>

                    </>
                    
                    ))) : (
                  <tr>
                    <td colSpan={4} className="py-4 px-4 text-center">
                      Nenhuma configuração de agendamento encontrada.
                    </td>
                  </tr>
                )}
              
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>

    </div>
  );
};

export default AppointmentList; 